export default __webpack_public_path__ + "static/media/burnsmcdonnell_blog.ab451dbc.png";